import { ActionTypes } from "../constants";

export default function cart(state = {}, action) {
  switch(action.type) {
    case ActionTypes.SET_CART_COUNTS:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
}